import { Controller } from "@hotwired/stimulus"
import { editorStore } from "../editor/store"

// Mobile-only onboarding hint above the dock. Shown while there are no
// objects on the plot. Auto-hides as soon as the first object is placed,
// or the user dismisses it manually.
export default class extends Controller {
  connect() {
    this._dismissed = this.#readDismissed()
    this._onChange = () => this.#update()
    editorStore.addEventListener("objects:change", this._onChange)
    editorStore.addEventListener("plot:change", this._onChange)
    this.#update()
  }

  disconnect() {
    editorStore.removeEventListener("objects:change", this._onChange)
    editorStore.removeEventListener("plot:change", this._onChange)
  }

  dismiss() {
    this._dismissed = true
    try { localStorage.setItem("plot-planner:onboarding-hint-dismissed", "1") } catch (_) {}
    this.element.classList.add("hidden")
  }

  #update() {
    const shouldShow = !this._dismissed && editorStore.objects.length === 0
    this.element.classList.toggle("hidden", !shouldShow)
  }

  #readDismissed() {
    try { return localStorage.getItem("plot-planner:onboarding-hint-dismissed") === "1" } catch (_) { return false }
  }
}
